import { useEffect } from 'react';
import { sfx } from './engine.js';
import type { SfxName } from './sounds.js';

/**
 * Eventos `window` (los mismos que ya emite el pipeline) → SFX. Un solo lugar
 * para los sonidos que se derivan de eventos de ciclo de sesión, en vez de
 * tocar cada componente.
 *
 * Nota: las celebraciones (subir de nivel, unidad completa, sub-unidad) NO van
 * acá — se disparan desde `<CelebrationLayer sound=…>` para quedar acopladas a
 * la misma transición visual y no doble-disparar.
 */
const EVENT_SOUND: Readonly<Record<string, SfxName>> = {
  'orborix:session.ended': 'session-end',
  'orborix:session.closing': 'idle-warning',
};

/** Suscribe los eventos de sesión a sus SFX. Montar una sola vez (en el shell). */
export function useSfxRouter(): void {
  useEffect(() => {
    const bound: Array<readonly [string, EventListener]> = Object.entries(EVENT_SOUND).map(
      ([event, name]) => {
        const handler: EventListener = () => sfx.play(name);
        window.addEventListener(event, handler);
        return [event, handler] as const;
      },
    );
    return () => {
      for (const [event, handler] of bound) window.removeEventListener(event, handler);
    };
  }, []);
}
